import { usePermissions } from '@/hooks/usePermissions';

/** The API's own read grants on the assignee lookup's catalogs; false until /profile arrives. */
export function useCanReadOrgCatalogs(): boolean {
  const { can } = usePermissions();
  return (
    can('User', 'read') &&
    can('OrgFunction', 'read') &&
    can('System', 'read') &&
    can('ExternalContact', 'read')
  );
}
